export default __webpack_public_path__ + "static/media/tutorial-step-2.3b0a0c68.png";